import React from 'react';
import Draggable from 'react-draggable';

const DraggableBlock = ({ children, ...props }) => (
  <Draggable {...props}>{children}</Draggable>
);

export default DraggableBlock;
